import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { StorageService } from '../services/storage.service';
import { CocheSeguro } from '../modelos/cocheSeguro.model';

export class Configuration {
    SOCIOQUATTRO: number;
    VERSION_PROYECTO: string;
    SNACK_BARTIME: number;
    S4_KEY: string;
    PROJECT_KEY: string;
    IS_DEBUG: boolean;
    UPLOAD_URL: string;
    ONBOARDING: string;
    URL: string;
    URLMASTER: string;
    URLQUATTROAUTOS: string;
    URLQUATTROAUTOAXA: string;
    URLASEGURADORA: string;
    URLAUTH: string;
    UPLOAD_URL_ADJUNTOS: string;
    UTILERIAS_ENDPOINT_AES: string;
    EMAIL_VALIDATION_AES: string;
    QUATTRO_MOVIL_ENDPOINT_AES: string;
    MESSAGING_SERVICE_ENDPOINT_AES: string;
    URLPOLIZAS: string;
    URLOperaciones: string;
    URLPolizaVehiculo: string;
    URLUtileria: string;
    URLDATATRANSFER: string;
    URLQUATTROAUTOSWS: string;
    URLCOTIZACION:string;
    URLUTILERIAS: string;
    URLIMPRESIONES: string;
    URLMIPOLIZA: string;
    URLPOLIZALAZY: string;
    URLPASARELA: string;
    URLCLIENTE: string;
    URLQUATTROAUTH: string;
    URLESTRUCTURA: string;
    APIGATEWAY: string;
    public URLQUATTROAUTO: string;
    public client_id: string;
    public client_secret: string;
    public URLINTER: string;
    public URLQUATTROAXA: string;
    public URLQuattroInbroker: string;
    public URL_SHORTENER_AES: string;
    public WEB_DB_AES = "https://web-db-aes-dot-sio4-168120.appspot.com/";
    private storageService: StorageService = new StorageService();
    public worksiteId: number = 0;
    public worksiteIdEncr: string = "";
    public PLATFORM: boolean = false;
    public URLPLATFORM: string = '';
    MULTINEGOCIO_ID: number;
    public CLOUD_FIRESTORE_AES_URL = '';
    BRIDGE_DATA_STRUCTURE_BI_AES: string;
    public isProd: boolean = true;
    cocheLimiteSerie: number;
    cocheLimitePlacas: number;
    hostname = window.location.hostname;
    hostnameKavak = 'cocheseguro4seller.inter.mx'; //KAVAK

    constructor() {
        this.SOCIOQUATTRO = 84;
        this.VERSION_PROYECTO = '0.0.0 24-Mayo-2020'
        this.SNACK_BARTIME = 4000;
        this.S4_KEY = 'uLmdvb2dsZS5jb20vY2hhdC1kYXRhYmFzZS05NTdjMSIsIm5hbWUiOiJIZWJlc';
        this.PROJECT_KEY = 'm';
        this.IS_DEBUG = false;
        this.worksiteId = 3;
        if (this.hostname === this.hostnameKavak){
            this.MULTINEGOCIO_ID = 171;//171 es para producccion de kavak
        } else {
            this.MULTINEGOCIO_ID = 61;//61 es para producccion y 67 es la copia para QA
        }
        this.worksiteIdEncr = "Iq11nyEuKhO2atPO7zevuw==";
        this.PLATFORM = this.getPlatform();
        this.URLPLATFORM = this.getUrlPlatform();
        this.APIGATEWAY = "https://api.quattrocrm.mx/"
        /**despues de los cambios se utiliza esta URL como final para agregar datos al storage */
        //this.UPLOAD_URL = 'https://fileupload-aes-dot-quattrocrm-201805.appspot.com/';         
        //this.URLMASTER = "https://quattrocrm-master-aes-dot-sio4-168120.appspot.com/";
        this.URLMASTER = "https://quattrocrm-master-aes-dot-quattrocrm-201805.appspot.com/";
        this.URLQUATTROAUTOS = 'https://quattro-autos-ws-aes-dot-quattrocrm-201805.appspot.com/';
        this.URLQUATTROAUTOAXA = 'https://api.quattrocrm.mx/';
        this.URLASEGURADORA = 'https://api.quattrocrm.mx/';
        this.URLAUTH = 'https://api.quattrocrm.mx/auth/';
        this.client_id = 'z0PKRSO3cV7b6yj2blDt3n3UFPaErjN8';
        this.client_secret = '074mcPc01xgTd-K5Iq70IsygkhnyUaK4DNIYGVFsiwFX6kgSHONsQcQwi8S8D3ZO';
        this.ONBOARDING = 'https://inter-onboarding-prod.uc.r.appspot.com/';
        this.QUATTRO_MOVIL_ENDPOINT_AES = 'https://quattro-movil-dot-quattrocrm-201805.appspot.com/';
        this.MESSAGING_SERVICE_ENDPOINT_AES = 'https://quattro-crm-notificaciones-aes-dot-quattrocrm-201805.appspot.com/';
        this.UPLOAD_URL_ADJUNTOS = 'https://file-upload-capp-aes-dot-quattrocrm-201805.appspot.com/'; // AES
        this.UTILERIAS_ENDPOINT_AES = 'https://sio4-utilerias-aes-dot-quattrocrm-201805.appspot.com/'; // AES PROD
        //this.EMAIL_VALIDATION_AES = "https://sio4-utilerias-aes-dot-sio4-168120.appspot.com/"; // AES QA
        this.URL_SHORTENER_AES = "https://quattro-shortener-aes-dot-quattrocrm-201805.appspot.com/";
        this.BRIDGE_DATA_STRUCTURE_BI_AES = "https://bridge-data-structure-bi-aes-dot-quattrocrm-201805.appspot.com/"; // AES PROD
        this.URLQUATTROAUTO = this.APIGATEWAY + 'auto/';
        this.URLINTER = "https://api.inter.mx/v1/";
        this.URLQUATTROAXA = this.APIGATEWAY + 'auto/';
        this.URLPASARELA = 'https://quattro-secure-d4f4hpx6ga-uc.a.run.app/secure/';
        this.cocheLimiteSerie = 17;
        this.cocheLimitePlacas = 10;

        // Servicios AES                                         
        switch (window.location.hostname) {
            case "localhost":// case "quattroqa.copsis.com":
                // this.URLQUATTROAUTOS = 'https://quattro-autos-ws-aes-dot-sio4-168120.uc.r.appspot.com/'
                this.WEB_DB_AES = "https://web-db-aes-dot-sio4-168120.appspot.com/"; //Skynet 
                this.CLOUD_FIRESTORE_AES_URL = 'https://cloud-firestore-aes-dot-quattro-firebase.appspot.com/'; //QA
                this.URLQUATTROAUTOS = 'https://quattro-autos-ws-aes-dot-sio4-168120.uc.r.appspot.com/';
                this.URLQUATTROAUTOAXA = 'https://api-gateway-afa5eqprsa-uc.a.run.app/';
                this.BRIDGE_DATA_STRUCTURE_BI_AES = "https://bridge-data-structure-bi-aes-dot-sio4-168120.uc.r.appspot.com/"; // AES QA
                this.isProd = false;
                this.APIGATEWAY = "https://api-gateway-afa5eqprsa-uc.a.run.app/";
                this.URLQUATTROAUTO = this.APIGATEWAY + 'auto/';
                this.URLQUATTROAXA = this.APIGATEWAY + 'auto/';
                this.URLINTER = "https://demos.Inter.mx/v1/";
                this.URLPASARELA = 'https://services.copsis.com:18081/secure/';
                this.URLOperaciones = "https://quattro-operacion-afa5eqprsa-uc.a.run.app/operacion";
                this.URLPolizaVehiculo = "https://quattro-poliza-afa5eqprsa-uc.a.run.app/poliza";
                this.URLUtileria = "https://quattro-utilerias-afa5eqprsa-uc.a.run.app/utilerias";
                this.URLCOTIZACION = "https://api.quattrocrm.mx/autos/publics";
                break;
            case "integration.copsis.com": case "develop.copsis.com":
            case "inter-autos-covid-qa.web.app":
            case 'inter-autos-qa.web.app':
            case "skynet.copsis.com": case "genesis.copsis.com":
                /* this.WEB_DB_AES = "https://web-db-aes-dot-sio4-168120.appspot.com/"; //Skynet */
                // this.URLQUATTROAUTOS = 'https://quattro-autos-ws-aes-dot-sio4-168120.uc.r.appspot.com/';
                // this.WEB_DB_AES = "https://web-db-aes-dot-quattrocrm-201805.appspot.com/"; //PROD
                this.WEB_DB_AES = "https://web-db-aes-dot-sio4-168120.appspot.com/"; //Skynet 
                this.CLOUD_FIRESTORE_AES_URL = 'https://cloud-firestore-aes-dot-quattro-firebase.appspot.com/'; //QA
                this.URLQUATTROAUTOS = 'https://quattro-autos-ws-aes-dot-sio4-168120.uc.r.appspot.com/'; //QA
                this.URLQUATTROAUTOAXA = 'https://api-gateway-afa5eqprsa-uc.a.run.app/';
                this.BRIDGE_DATA_STRUCTURE_BI_AES = "https://bridge-data-structure-bi-aes-dot-sio4-168120.uc.r.appspot.com/"; // AES QA
                this.APIGATEWAY = "https://api-gateway-afa5eqprsa-uc.a.run.app/";
                this.URLQUATTROAUTO = this.APIGATEWAY + 'auto/';
                this.URLQUATTROAXA = this.APIGATEWAY + 'auto/';
                this.URLCOTIZACION = "https://api.quattrocrm.mx/autos/publics"
                this.URLINTER = "https://demos.Inter.mx/v1/";
                this.URLPASARELA = 'https://services.copsis.com:18081/secure/';
                this.URLOperaciones = "https://quattro-operacion-afa5eqprsa-uc.a.run.app/operacion";
                this.URLPolizaVehiculo = "https://quattro-poliza-afa5eqprsa-uc.a.run.app/poliza";
                this.URLUtileria = "https://quattro-utilerias-afa5eqprsa-uc.a.run.app/utilerias";
                this.isProd = false;
                this.APIGATEWAY = "https://api-gateway-afa5eqprsa-uc.a.run.app/";
                this.URLQUATTROAUTO = this.APIGATEWAY + 'auto/';
                break;
            default:
                // Producción(quattrocrm1.copsis.com, ...)
                this.WEB_DB_AES = "https://web-db-aes-dot-quattrocrm-201805.appspot.com/"; //PROD
                this.CLOUD_FIRESTORE_AES_URL = 'https://cloud-firestore-aes-dot-quattrocrm-201805.uc.r.appspot.com/'; // PROD
                this.URLOperaciones = "https://api.quattrocrm.mx/operacion";
                this.URLPolizaVehiculo = "https://api.quattrocrm.mx/poliza";
                this.URLUtileria = "https://api.quattrocrm.mx/utilerias";
                this.URLINTER = "https://api.inter.mx/v1/";
                break;
        }


        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }

        this.URL = cocheSeguro?.dominioMkp + '/sio4amarketplace/';
        this.URLPOLIZAS = cocheSeguro?.dominioMkp + '/sio4apolizas-new/';
        this.URLDATATRANSFER = cocheSeguro?.dominioMkp + '/data-transfer-api/';
        this.URLQUATTROAUTOSWS = cocheSeguro?.dominioMkp + '/quattro-autos-ws/';
        this.URLUTILERIAS = cocheSeguro?.dominioMkp + '/sio4autilerias/';
        this.URLIMPRESIONES = cocheSeguro?.dominioMkp + '/sio4aimpresiones/';
        this.URLMIPOLIZA = cocheSeguro?.dominioMkp + '/mipoliza-api/';
        this.URLPOLIZALAZY = cocheSeguro?.dominioMkp + '/sio4apolizas-lazy-fetch/';
        this.URLCLIENTE = cocheSeguro?.dominioMkp + '/sio4aclientes-new/';
        this.URLQUATTROAUTH = cocheSeguro?.dominioMkp + '/quattro-auth/';
        this.URLESTRUCTURA = cocheSeguro?.dominioMkp + '/sio4aestructura-new/';
        this.URLQuattroInbroker = cocheSeguro?.dominioMkp + "/sio4ainbroker/";
    }

    getPlatform(): boolean {
        if (navigator.platform.toLowerCase().includes('iphone') && navigator.userAgent.toLowerCase().includes('iphone') && navigator.appVersion.toLowerCase().includes('iphone')) {
            return true;
        } else {
            return false;
        }
    }

    getUrlPlatform(): string {
        if (window.location.hostname == 'localhost') {
            return 'http://' + window.location.hostname + ':' + window.location.port + '/';
        } else {
            return 'https://' + window.location.hostname + '/';
        }
    }
}

export class Encrypted {
    ZERO: string;
    UNO: string;
    DOS: string;
    TRES: string;
    CUATRO: string;
    CINCO: string;
    SEIS: string;
    SIETE: string;
    OCHO: string;
    NUEVE: string;
    DIEZ: string;
    ONCE: string;
    DOCE: string;
    TRECE: string;
    CATORCE: string;
    QUINCE: string;
    DIESICEIS: string;
    DIESICIETE: string;
    DIESIOCHO: string;
    DIESINUEVE: string;
    VEINTE: string;
    VEITIUNO: string;
    VEITIDOS: string;
    VEINTITRES: string;
    VEINTICUATRO: string;
    VEINTICINCO: string;
    VEINTISEIS: string;
    VEINTISIETE: string;
    VEINTIOCHO: string;
    VEINTINUEVE: string;
    TREINTA: string;
    TREINTAYUNO: string;
    TREINTAYTRES: string;
    TREINTAYCUATRO: string;
    SETENTAYUNO: string;
    CUARENTAYCINCO: string;
    SESENTAYTRES: string;
    SESENTAYCUATRO: string;

    constructor() {
        this.ZERO = "l66xHtlkmi56Uqz3MEYuqw==";
        this.UNO = "94c3qaBTlOBbdUWPBkxEmg==";
        this.DOS = "f917Va5WwTC+2N4o3l4+BA==";
        this.TRES = "Iq11nyEuKhO2atPO7zevuw==";
        this.CUATRO = "EqCZqGFttusLNojjyxsIBQ==";
        this.CINCO = "DkxlYDgr8ppqraux+geoWQ==";
        this.SEIS = "NrJZ2eu8864dVTrtvx+UWQ==";
        this.SIETE = "yvzHgyDWbKBDnl9x3vHpyw==";
        this.OCHO = "HPprvkjaW3dEDhHb4rMbUw==";
        this.NUEVE = "G3qKOv/JCLtcizqrY/DUUg==";
        this.DIEZ = "BZkFTQl+/ypfyS8ecK8cDQ==";
        this.ONCE = "BHj2Q7IqI3UAMAvoFTMpHg==";
        this.DOCE = "PYYCJxaUzGWcuzoy4aVrEw==";
        this.TRECE = "q5pNsocdNEy34aRW1AXEkQ==";
        this.CATORCE = "NOwi9GtnliNcum4Bsam09Q==";
        this.QUINCE = "8CgddnXyqkVSMum/oKjifg==";
        this.DIESICEIS = "YcOJ/i++O0aZ37B7J8KRGg==";
        this.DIESICIETE = "H/QTfZ6fL66wuho1zdnzSg==";
        this.DIESIOCHO = "/k9PiRJ01NnBnN4pcfPzQQ==";
        this.DIESINUEVE = "UbOxuPNiFuGGuLxKgMMFPg==";
        this.VEINTE = "vr0Iqzix9uaS9cyiQF490w==";
        this.VEITIUNO = "s6AlIo/7ITm5aqHXfmJDBQ==";
        this.VEITIDOS = "qS0T0zyrYPon/Z9j6k56pA==";
        this.VEINTITRES = "JgcYdqdOA1LYdEZxZo6BJg==";
        this.VEINTICUATRO = "2iLVMs9V62MzItYn3gpj+Q==";
        this.VEINTICINCO = "4ZtLpd2BqE6sLPcllqYI5Q==";
        this.VEINTISEIS = "4MWOMT3P8OX+xwHJe1VusA==";
        this.VEINTISIETE = "aWaY1nKdEWDXzHVgm3jbTw==";
        this.VEINTIOCHO = "YLIMtcwCUjJ6pVv3rW2+Dw==";
        this.VEINTINUEVE = "nZmCFHLBLCdgpzGYE8muHg==";
        this.TREINTA = "ITHx8Tgrcck395BMh9xaCw==";
        this.TREINTAYUNO = "tR8z7IRsRYkb9Nz2eOkuuQ==";
        this.TREINTAYTRES = "N/6EdiG+9FGhKBKG9xi+cA==";
        this.TREINTAYCUATRO = "//Ezav7KBIrvxm6GbdEnZA==";
        this.SETENTAYUNO = "KLwPDUpeeBystYhHI/1/Dg==";
        this.CUARENTAYCINCO = "U+BBTdHMwty+3JOd7bMckg==";
        this.SESENTAYTRES = "J+ul8mAoOnflIMIf22+X7g==";
        this.SESENTAYCUATRO = "dCJLUlRAhlAyXFwlyWBvTg==";
    }
}